var divider_viewer_default = {
  "divider-container": "JktQq",
  "divider-container--double": "YCU3S",
  "divider": "TGlOp",
  "divider--single": "_2w5kX",
  "divider--double": "_6AO0z",
  "divider--dashed": "giGhQ",
  "divider--dotted": "_5Lguf",
  "divider--small": "_9CbqK",
  "divider--medium": "OFzlN",
  "divider--large": "_1yX7z",
  "divider--left": "kvthU",
  "divider--center": "KC7-k",
  "divider--right": "_2cqzp",
  "svgFixerContainer": "PnnZP",
  "emptyChar": "go1uA"
};
export {
  divider_viewer_default as default
};
//# sourceMappingURL=divider-viewer-scss.js.map
